import { useActor } from '@xstate/react';
import classNames from 'classnames';
import { InterpreterFrom } from 'xstate';
import { BorderBottom, BorderClear, FlipToFront, BlurOn } from '@styled-icons/material';
import { NavbarContainerOptionsMachineType } from '../../../nodes/navbar/fsm/NavbarContainer.fsm';
import styles from '../Navbar.module.css';
import { NAVBAR_STYLE } from '../../../constants';

export function NavbarStyleOptions(props: {
  machine: InterpreterFrom<NavbarContainerOptionsMachineType>;
}) {
  const { machine } = props;
  const [machineState, machineSend] = useActor(machine);
  const content = machineState.context?.dataNavbar;

  return (
    <div className={styles.navbarOptions}>
      <div className={styles.navbarOptionsTitle}>Style</div>
      <div
        role="none"
        className={classNames(styles.navbarOptionsItem, {
          [styles.navbarOptionsItemActive]: content?.style === NAVBAR_STYLE.SHADOW,
        })}
        onClick={() =>
          machineSend({
            type: 'NAVBAR.STYLE.CHANGE',
            payload: NAVBAR_STYLE.SHADOW,
          })
        }
      >
        <FlipToFront size={18} />
      </div>
      <div
        role="none"
        className={classNames(styles.navbarOptionsItem, {
          [styles.navbarOptionsItemActive]: content?.style === NAVBAR_STYLE.BORDER,
        })}
        onClick={() =>
          machineSend({
            type: 'NAVBAR.STYLE.CHANGE',
            payload: NAVBAR_STYLE.BORDER,
          })
        }
      >
        <BorderBottom size={18} />
      </div>
      <div
        role="none"
        className={classNames(styles.navbarOptionsItem, {
          [styles.navbarOptionsItemActive]: content?.style === NAVBAR_STYLE.PLAIN,
        })}
        onClick={() =>
          machineSend({
            type: 'NAVBAR.STYLE.CHANGE',
            payload: NAVBAR_STYLE.PLAIN,
          })
        }
      >
        <BorderClear size={18} />
      </div>
      <div className={styles.navbarOptionsSeparator} />
      <div
        role="none"
        className={classNames(styles.navbarOptionsItem, styles.navbarOptionsItemButton)}
        onClick={() =>
          machineSend({
            type: 'NAVBAR.BLUR.CHANGE',
            payload: !machineState.context.dataNavbar?.isBlur ?? true,
          })
        }
      >
        Blur
        <BlurOn
          size={18}
          className={classNames(content?.isBlur && 'with-accent-text-color', 'ml-1')}
        />
      </div>
    </div>
  );
}
